import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import appData from "data/app.json";
import { GetBlogPostData } from "components/ApiServices/GetBlogPostsdata";
import { GetServicesData } from "components/ApiServices/GetServicesData";
import { GetTechnologies } from "components/ApiServices/GetTechnologies";
import { GetProjectsData } from "components/ApiServices/GetProjectsData";
import { GatsbyImage } from "gatsby-plugin-image";

const Footer = ({ hideBGCOLOR, theme }) => {
  const recentNewsData = GetBlogPostData();
  const servicesData = GetServicesData();
  const allProjects = GetProjectsData();
  const footerProjects = allProjects.slice(0, 10);
  const technologies = GetTechnologies();
  const flattenedTechnologies = [].concat(...technologies);

  const [year, setYear] = useState(null);

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const _resolveTimestamp = (timeStamp) => {
    const date = new Date(timeStamp).toLocaleDateString("en-US");
    return date;
  };

  return (
    <>
      <div className="desktop-links sub-bg footer-add-links position-relative">
        <div className="f-link">
          <div className="f-head mb-20">
            <h5>Services</h5>
          </div>

          <div className="link-list d-flex flex-row column-gap-3">
            <ul className="d-flex flex-column">
              {servicesData.map((service, index) => (
                <React.Fragment key={index}>
                  {service?.technologiesData &&
                    service?.technologiesData?.nodes
                      .slice(0, 2)
                      .map((technology, index) => (
                        <Link
                          onClick={() => {
                            checkPaceClass();
                          }}
                          to={`/services/${service?.slug}/${technology?.slug}`}
                          key={index}
                        >
                          <li>{technology?.title}</li>
                        </Link>
                      ))}
                </React.Fragment>
              ))}
              <li
                onClick={() => {
                  checkPaceClass();
                }}
              >
                <a href="/one-time-marketing-pack">Digital Marketing</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="f-tech tech">
          <div className="f-head mb-20">
            <h5>Technologies</h5>
          </div>

          <div className="link-list d-flex flex-row column-gap-3">
            <ul className="d-flex flex-column">
              {flattenedTechnologies &&
                flattenedTechnologies?.slice(0, 6).map((technology, index) => (
                  <Link
                    to={`/technologies/${technology?.slug}`}
                    onClick={() => {
                      checkPaceClass();
                    }}
                    key={index}
                  >
                    <li>{technology?.title}</li>
                  </Link>
                ))}
            </ul>
          </div>
        </div>

        <div className="f-tech">
          <div className="f-head mb-20">
            <h5>Industries</h5>
          </div>

          <div className="link-list d-flex flex-row column-gap-3">
            <ul className="d-flex flex-column">
              <li>Resturants</li>
              <li>Real Estate</li>
              <li>E-Commerce</li>
              <li>Education</li>
              <li>Saas</li>
            </ul>
          </div>
        </div>

        <div className="f-tech">
          <div className="f-head mb-20">
            <h5>Projects</h5>
          </div>

          <div className="link-list d-flex flex-row column-gap-3">
            <ul className="d-flex flex-column">
              {footerProjects.slice(0, 6).map((Project, index) => (
                <Link
                  to={`/work/${Project?.slug}`}
                  onClick={() => {
                    checkPaceClass();
                  }}
                  key={index}
                >
                  <li>{Project?.projectName}</li>
                </Link>
              ))}
            </ul>
          </div>
        </div>

        <div className="f-tech">
          <div className="f-head mb-20">
            <h5>About Us</h5>
          </div>

          <div className="link-list">
            <ul className="d-flex flex-column">
              <Link
                onClick={() => {
                  checkPaceClass();
                }}
                to="/about"
              >
                <li>About</li>
              </Link>

              <Link
                onClick={() => {
                  checkPaceClass();
                }}
                to="/contact"
              >
                <li>Contact Us</li>
              </Link>

              <Link
                onClick={() => {
                  checkPaceClass();
                }}
                to="/blog"
              >
                <li>Blog</li>
              </Link>

              <Link
                onClick={() => {
                  checkPaceClass();
                }}
                to="/privacy-policy"
              >
                <li>Privacy Policy</li>
              </Link>
            </ul>
          </div>
        </div>
      </div>

      <div className="mobile-links container flex-wrap sub-bg footer-add-links position-relative">
        <div className="accordion" id="accordion">
          <div className="card f-tech">
            <div className="card-header" id="headingOne">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <div className="f-head">
                  <h5>Services</h5>
                </div>
              </button>
            </div>

            <div
              id="collapseOne"
              className="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="link-list d-flex flex-row column-gap-3">
                  <ul className="d-flex flex-column">
                    {servicesData.map((service, index) => (
                      <React.Fragment key={index}>
                        {service?.technologiesData &&
                          service?.technologiesData?.nodes
                            .slice(0, 2)
                            .map((technology, index) => (
                              <Link
                                onClick={() => {
                                  checkPaceClass();
                                }}
                                to={`/services/${service?.slug}/${technology?.slug}`}
                                key={index}
                              >
                                <li>{technology?.title}</li>
                              </Link>
                            ))}
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordion">
          <div className="card f-tech">
            <div className="card-header" id="headingTwo">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                <div className="f-head">
                  <h5>Technologies</h5>
                </div>
              </button>
            </div>

            <div
              id="collapseTwo"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="link-list d-flex flex-row column-gap-3">
                  <ul className="d-flex flex-column">
                    {flattenedTechnologies &&
                      flattenedTechnologies
                        ?.slice(0, 6)
                        .map((technology, index) => (
                          <Link
                            onClick={() => {
                              checkPaceClass();
                            }}
                            to={`/technologies/${technology?.slug}`}
                            key={index}
                          >
                            <li>{technology?.title}</li>
                          </Link>
                        ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordion">
          <div className="card f-tech">
            <div className="card-header" id="headingThree">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                <div className="f-head">
                  <h5>Industries</h5>
                </div>
              </button>
            </div>

            <div
              id="collapseThree"
              className="collapse"
              aria-labelledby="headingThree"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="link-list d-flex flex-row column-gap-3">
                  <ul className="d-flex flex-column">
                    <li>Resturants</li>
                    <li>Real Estate</li>
                    <li>E-Commerce</li>
                    <li>Education</li>
                    <li>Saas</li>
                    <li>News</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordion">
          <div className="card f-tech">
            <div className="card-header" id="headingFour">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                <div className="f-head">
                  <h5>Projects</h5>
                </div>
              </button>
            </div>

            <div
              id="collapseFour"
              className="collapse"
              aria-labelledby="headingFour"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="link-list d-flex flex-row column-gap-3">
                  <ul className="d-flex flex-column">
                    {footerProjects.slice(0, 6).map((Project, index) => (
                      <Link
                        to={`/work/${Project?.slug}`}
                        onClick={() => {
                          checkPaceClass();
                        }}
                        key={index}
                      >
                        <li>{Project?.projectName}</li>
                      </Link>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordion">
          <div className="card f-tech">
            <div className="card-header" id="headingFive">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="true"
                aria-controls="collapseFive"
              >
                <div className="f-head">
                  <h5>About Us</h5>
                </div>
              </button>
            </div>

            <div
              id="collapseFive"
              className="collapse"
              aria-labelledby="headingFive"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="link-list">
                  <ul className="d-flex flex-column">
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to="/about"
                    >
                      <li>About</li>
                    </Link>

                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to="/contact"
                    >
                      <li>Contact Us</li>
                    </Link>

                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to="/blog"
                    >
                      <li>Blog</li>
                    </Link>

                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to="/privacy-policy"
                    >
                      <li>Privacy Policy</li>
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="line right"></div>

      <footer className={`${!hideBGCOLOR ? "sub-bg position-relative" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="item md-mb50">
                <div className="title">
                  <h5>Contact Us</h5>
                </div>
                <ul>
                  <li>
                    <span className="icon pe-7s-map-marker"></span>
                    <div className="cont">
                      <h6>Official Address</h6>
                      <a
                        href="https://goo.gl/maps/WKCdTxeV5aHbTuYR7"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <p>
                          195-A, Lane 2, Kiran Vihar Extension, Ludhiana, Punjab
                          141022
                        </p>
                      </a>
                    </div>
                  </li>
                  <li>
                    <span className="icon pe-7s-mail"></span>
                    <div className="cont">
                      <h6>Email Us</h6>
                      <p>
                        {" "}
                        <a href="mailto:info@evolvan.com">
                          info@evolvan.com
                        </a>{" "}
                      </p>
                    </div>
                  </li>
                  <li>
                    <span className="icon pe-7s-call"></span>
                    <div className="cont">
                      <h6>Call Us</h6>
                      <p>
                        <a href="tel:+918360801493">+91 83608 01493</a>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="item md-mb50">
                <div className="title">
                  <h5>Recent News</h5>
                </div>
                <ul>
                  {recentNewsData &&
                    recentNewsData.slice(0, 2).map((news, i) => (
                      <li key={i} className="d-flex">
                        <div className="mr-2">
                          <Link
                            onClick={() => {
                              checkPaceClass();
                            }}
                            to={`/blog/${news?.slug}`}
                            aria-label={`Read more about ${news?.title}`}
                          >
                            {news?.featuredImage?.node?.localFile
                              ?.childImageSharp?.gatsbyImageData ? (
                              <GatsbyImage
                                className="blog-img"
                                loading="lazy"
                                image={
                                  news.featuredImage.node.localFile
                                    .childImageSharp.gatsbyImageData
                                }
                                alt={`${news?.title}`}
                              />
                            ) : (
                              <div className="blog-img" aria-hidden="true" />
                            )}
                          </Link>
                        </div>
                        <div className="sm-post d-flex flex-column">
                          <Link
                            onClick={() => {
                              checkPaceClass();
                            }}
                            to={`/blog/${news?.slug}`}
                          >
                            <p>{news?.title}</p>
                          </Link>
                          <span className="date mt-5">
                            {_resolveTimestamp(news?.date)}
                          </span>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="item">
                <div className="logo">
                  <div className="evlvn-logo">
                    <img
                      loading="lazy"
                      className="mainLogo"
                      src={
                        theme === "themeL" ? appData.darkLogo : appData.darkLogo
                      }
                      alt="Evolvan logo"
                    />
                  </div>

                  <div className="logos">
                    <img
                      className="mainLogo"
                      loading="lazy"
                      src="/img/ITCA_logo_0300x300.webp"
                      alt="ITCA Logo"
                      content="noindex, nofollow"
                    ></img>

                    <img
                      className="mainLogo"
                      loading="lazy"
                      src="/img/esc-logo-1-600x234.png"
                      alt="ESC Logo"
                      content="noindex, nofollow"
                    ></img>
                    <img
                      className="mainLogo"
                      loading="lazy"
                      src="/img/upwork.png"
                      alt="Upwork Logo"
                      content="noindex, nofollow"
                    ></img>
                    <img
                      className="mainLogo"
                      loading="lazy"
                      src="/img/clutch.png"
                      alt="Clutch Logo"
                      content="noindex, nofollow"
                      style={{ width: "80px" }}
                    ></img>
                    <img
                      className="mainLogo"
                      loading="lazy"
                      src="/img/google-review.png"
                      alt="Google Reviews badge"
                      content="noindex, nofollow"
                      style={{ width: "80px" }}
                    ></img>
                  </div>
                </div>
                <div id="social-icons" className="social">
                  <a
                    href="http://g.page/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Find us on Google Maps"
                  >
                    <i className="fa fa-map-marker"></i>
                  </a>
                  <a
                    href="http://fb.com/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="http://twitter.com/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on Twitter"
                  >
                    <i className="fab fa-x-twitter"></i>
                  </a>
                  <a
                    href="http://linkedin.com/company/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on LinkedIn"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a
                    href="https://www.behance.net/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit us on Behance"
                  >
                    <i className="fab fa-behance"></i>
                  </a>
                  {/* <a
                    href="https://dribbble.com/evolvan"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-dribbble"></i>
                  </a> */}
                  <a
                    href="https://www.youtube.com/@evolvan9"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit us on YouTube"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/evolvan9/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit us on Instagram"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
                <div className="copy-right">
                  <p>
                    &copy; {year}, Evolvan Info Solutions Pvt Ltd.
                    <Link
                      onClick={() => {
                        checkPaceClass();
                      }}
                      to="/"
                      target="_blank"
                    >
                      Evolvan
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
